import {useEffect} from 'react'
import Cookies from 'universal-cookie'

const cookies = new Cookies()

// GA Documentation
//   https://developers.google.com/analytics/devguides/collection/analyticsjs/events

export const GoogleAnalytics = (props) => {
  useEffect(() => {
    const debug = !!cookies.get('ga_debug')

    // Support old disable-mechanism
    if (cookies.get(`ga-disable-${props.gaProfileId}`)) return null

    // Include GA script
    const firstScript = document.getElementsByTagName('script')[0]
    let gaScript = document.createElement('script')
    gaScript.async = true
    gaScript.src = `https://www.google-analytics.com/analytics${debug ? '_debug' : ''}.js`
    firstScript.parentNode.insertBefore(gaScript, firstScript)

    // Execute GA init ceremony
    if (debug) window.ga_debug = {trace: true}
    window.ga('create', props.gaProfileId)
    window.ga('set', 'anonymizeIp', true)
    window.ga('set', 'dimension1', cookies.get('ga_dimension1'))
    window.ga('set', 'dimension2', getDevicePixelRatio())
    window.ga('set', 'dimension4', I18n.locale)
    if (window.gaTrackingPath) window.ga('set', 'dimension5', window.gaTrackingPath)
    if (props.gaOptimizeId) window.ga('require', props.gaOptimizeId)
    window.ga('send', 'pageview')

    if (window.gaTrackingPathDebug) {
      const current_url = window.location.pathname + window.location.search + window.location.hash
      window.ga('send', 'event', 'tracking path debugging', window.gaTrackingPathDebug, current_url, {nonInteraction: true})
    }
  }, [])

  return null
}

/* GetDevicePixelRatio | Author: Tyson Matanich, 2012 | License: MIT */
/* https://github.com/tysonmatanich/GetDevicePixelRatio */
const getDevicePixelRatio = function () {
  var ratio = 1;
  // To account for zoom, change to use deviceXDPI instead of systemXDPI
  if (window.screen.systemXDPI !== undefined && window.screen.logicalXDPI !== undefined && window.screen.systemXDPI > window.screen.logicalXDPI) {
    // Only allow for values > 1
    ratio = window.screen.systemXDPI / window.screen.logicalXDPI;
  }
  else if (window.devicePixelRatio !== undefined) {
    ratio = window.devicePixelRatio;
  }

  /* Customization for betterplace: we want a rounded value, 1 decimal position, as string: */
  return (Math.round(ratio * 10) / 10).toString();
};
